import service from './api'
import {languageValidation} from '../../utils/language-validation'

class EncodingService {
    
    executeInputString(input) {
        console.log("calling input string")
        return service.get("/input-string/" + input)
    }
    executeInputString_submit(input, currentTargetSupplyData,ip,lat,lon, language) {
        console.log("calling input string")
        language=languageValidation(language);
        return service.post("/v1/sign",
                                    {
                                            jwe: input,
                                            targetSupply : currentTargetSupplyData,
                                             ipAddress : ip,
                                             latitude  : lat,
                                            longitude : lon,
                                            browserLanguage: language
                                        },
                                    {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    })

    }

    executeInputString_submitError(input, ip, lat, lon, language) {
        console.log("calling input string")
        language=languageValidation(language);
        return service.post("/v1/reportError",
            {
                    jwe: input,
                    ipAddress : ip,
                    latitude  : lat,
                    longitude : lon,
                    browserLanguage: language

                },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            })
    }

    //DB SAVE Added to call Back End....
    addNewAccount(account) {
        return service.post("v1/businesses", account);
    }
    //Get All account from DB
    getAllAccount() {
        return service.get("v1/businesses");
    }

    getRolesByBusiness(id){
        return service.get('/v1/role?businessId=' + id)
    }

    getAllUser() {
        let config=  {headers:{
            'APP_URL':window.location.href
        }}
        return service.get("v1/users",config);
    }

    getPrinterCatalogList(){
                 return service.get("v1/printers/catalog");
    }

    addPrinter(obj){
        console.log(obj);
        return service.post("v1/printers", obj);
    }
    delFirmware(obj){
    console.log(obj);
    return service.delete("v1/printers/delete/"+obj);
    }

    delPrinter(obj){
        console.log(obj);
        return service.delete("v1/printers/"+obj);
        }

    updateFirmwareAsActive(printerId,firmwareId) {
                    return service.put("/v1/printers/"+printerId+"/firmware/"+firmwareId);
                }

    addNewUser(user) {
        return service.post("v1/users", user);
    }
     updateUser(user) {
            return service.put("v1/users/"+user.id,user);
        }
    //Update account details
    updateBusinessAccount(business) {
        return service.put("v1/businesses/"+business.id,business);
    }

    updateBusinessAddress(obj){
        return service.put("/v1/businesses/address/"+obj.id, obj);
    }

    downloadAnalytics(reportYear, reportMonth, selectedBusinessId){
        return service.get("/v1/export/analytics/"+reportYear+"/"+reportMonth+"/"+selectedBusinessId,{ responseType: 'blob'})
    }

    downloadUsage(reportYear, reportMonth, selectedBusinessId){
        return service.get("/v1/export/excel/"+reportYear+"/"+reportMonth+"/"+selectedBusinessId,{ responseType: 'blob'})
    }

    downloadActivity(){
        return service.get("/v1/export/sps/activityLog",{ responseType: 'blob'})
    }

    updateBusinessMail(obj){
        return service.put("/v1/businesses/mail/"+obj.id, obj);
    }

    updateBusinessStatus(data){
        return service.put("/v1/businesses/status/"+data.id, data);
    }

    getAllSupplyCatalog() {
        return service.get("v1/supplies/families")
    }
    //addsuppliescatalog
    addSupplyFamily(supplyFamily){
        return service.post("v1/supplies/families", supplyFamily)
    }

    ///v1/supplies/targets
    newtargetsupply(supplyTarget){
            return service.post("v1/supplies/targets", supplyTarget)
        }

     ///v1/supplies/enable
     updateCurrentSupplyActive(obj){
     return service.put("/v1/supplies/enable", obj)
     }

    //Get Target Supplies Data
    getTargetSupplyData(){
        return service.get("v1/supplies");
    }

     getTargetSupplyDataAll(){
                return service.get("v1/allsupplies");
            }

    updateSupply(obj){
                return service.put("/v1/supplies/updatefamilies", obj);
         }

    updateTarget(obj){
                return service.put("/v1/supplies/updateTargetSupply", obj);
         }

    updateTargetSupplyFamily(obj){
        return service.put("/v1/supplies/updateTargetSupplyFamily", obj)
    }

    //Get All Printers/Firmwares
    getAllPrinters(){
        return service.get("v1/printers");
    }

    getMonthlyData(month,year){
        return service.get("v1/supplies/summary/"+year+"/"+month);
    }

    getSPSMonthlyData(month,year,business){
        return service.get("v1/supplies/sps/summary/"+year+"/"+month+"/"+business);
    }

    getUsageData(supply){
        return service.get("/v1/supplies/usage/"+supply);
    }
    deleteUser(id) {
        console.log("/supplyencodingsvc/v1/users/"+id)
        return service.delete("/v1/users/"+id);
    }
    
    getBusiness(id){
        return service.get("v1/businesses/"+id);
    }
    updateSupplies(e){
        return service.put("v1/supplies",e);
    }
    updateAdjustment(e){
        return service.post("v1/supplies/adjustment", e)
    }
   

     updateClearBusinessOwner(business){
        return service.put("v1/businesses/clearowner/"+ +business.id,business)
    }

    executeInputStringValid_submit(input) {
        console.log("calling input string")
        input.language=languageValidation(input.language);
        return service.post("/v1/validate",
                {
                        jwe: input.jwe,
                        targetSupply : "",
                        ipAddress : input.ipAddress,
                        latitude  : input.latitude,
                        longitude : input.longitude,
                        browserLanguage : input.language
                    },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                })
    }
    
    executeInputStringVerify_submit(input) {
        console.log("calling input string")
        input.language=languageValidation(input.language);
        return service.post("/v1/verify",
                {
                    jwe: input.jwe,
                    targetSupply : "",
                    ipAddress : input.ipAddress,
                    latitude  : input.latitude,
                    longitude : input.longitude,
                    browserLanguage : input.language
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                })
    }

        uploadPrinterFW(data){
                    console.log("Entered API call")
                    return service.post("/v1/printers/firmware", data,
                    {
                        'Accept': 'application/x-zip-compressed',
                        'Content-Type': 'multipart/form-data',
                    })
                }

        getPreSignedURLs(fileName, signatureName, publicKeyName) {
           return  service.get(`/v1/S3Object/uploadLink/${fileName}/${signatureName}/${publicKeyName}`);
        }

        postFileUploadCheck(printerId, firmwareName){
            return service.post("/v1/printers/firmware/check?printerID="+printerId+"&firmwareName="+firmwareName)
        }

        getS3PreSignedURLForDownload(fileName){
            return service.get( "/v1/S3Object/downloadLink/" + fileName);
        }

        getSoftwareCatalogList(){
            return service.get("v1/softwares/catalog");
        }

        addSoftware(obj){
            console.log(obj);
            return service.post("v1/softwares", obj);
        }

        delSoftwareFile(obj){
            console.log(obj);
            return service.delete("v1/softwares/delete/"+obj);
        }

        delSoftware(obj){
            console.log(obj);
            return service.delete("v1/softwares/"+obj);
        }

        postSWFileUploadCheck(swId,swName, signatureName, publicKeyName ){
            if (swName == null) swName = "";
            if (signatureName == null) signatureName = "";
            if (publicKeyName == null) publicKeyName = "";
            return service.post("v1/softwares/software/check?softwareID="+swId+"&softwareName="+swName+"&signatureKeyFileName="+signatureName+"&publicKeyFileName="+publicKeyName);
        }

        updateSoftwareFileAsActive(softwareId,softwareFileId) {
            return service.put("v1/Softwares/"+softwareId+"/software/"+softwareFileId);
        }

        getAllSoftwares(){
            return service.get("/v1/softwares");
        }

}

const encodingServiceInstance = new EncodingService();
export default encodingServiceInstance;
